import { Product } from "./content";

import { GetUserResponse } from "../../generated/pear-user-management/pear-user-management.pb";

export { type UserPreferences } from "../../generated/pear-user-management/user.pb";

export interface IIdentity {
  getIdentity: (options: GetIdentityOptions) => Promise<GetIdentityResponse>;
  identifyProduct: (product: Product) => void;
  identifyUser: (userIdentityToken: string) => void;
  openInitializeProductModal: (
    options: OpenInitializeProductModalOptions
  ) => void;
  setToken: (token: string) => void;
}

export type GetIdentityOptions = {};

export type GetIdentityResponse = GetUserResponse;

export type OpenInitializeProductModalOptions = {
  email: string;
  product: Product;
  followRedirectInModal?: boolean;
};

export type OpenInitializeProductModalResponse = {
  initialized: boolean;
};

export enum SignInIntent {
  InitUserTeacher = "init_user_teacher",
}
